import React, { VFC } from 'react';
import { ColumnInstance, FilterValue, IdType, Row } from 'react-table';
import { STAFF } from '../../../../../re-ducks/themes/types';

export const StaffTypeFilter = (
  rows: Array<Row<any>>,
  columnIds: Array<IdType<any>>,
  filterValue: FilterValue,
): Array<Row<any>> => {
  return rows.filter((row) => {
    return filterValue ? row.values[columnIds[0]] === filterValue : true;
  });
};

export const StaffFilter: VFC<{ column: ColumnInstance<never> }> = ({
  column,
}) => {
  const { id, render, setFilter, filterValue } = column;

  return (
    <div>
      <div className="label">{render('Header')}</div>
      <div className="control select is-block">
        <select
          className="select column is-full"
          name={id}
          value={filterValue || ''}
          onChange={(event) => setFilter(event.target.value || '')}
        >
          <option value="">選択してくだい</option>
          {STAFF.map((value) => (
            <option key={value} value={value}>
              {value}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
